module.exports = __webpack_public_path__ + "static/media/chevron-right-double.6c92b692.svg";